import React from 'react';
import {Download} from "lucide-react";
import {motion} from "framer-motion";

const DownloadVideo = ({handleDownload,isDownloading}) => {
    return <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={handleDownload}
            disabled={isDownloading}
            className="p-1.5 rounded-full hover:bg-white/20 transition-colors disabled:opacity-50"
        >
            <Download size={16} className="text-white" />
        </motion.button>

};

export default DownloadVideo;
